import React, { Component } from 'react'
import styled from 'styled-components'

import Icon from './ic-search.svg'

class NoResults extends Component {
  render () {
    return (
      <Wrapper>
        <Img src={Icon} alt={`Selecione os filtros..`} />
        <Text>
                    Não foram encontrados tarifários para a sua pesquisa
                </Text>
      </Wrapper>
    )
  }
}

export default NoResults

const Wrapper = styled.div`
    padding: 20vh 15%;
    display: flex;
    align-items: center;
    justify-content: center;
`

const Img = styled.img`
    width: 40px;
    height: 40px;
    margin-right: 10px;
`

const Text = styled.p`
    color: #BABABA;
    font-size: 20px;
    line-height: 28px;
`



// WEBPACK FOOTER //
// ./src/components/NoResults/index.js